export function formatDateStr(datestr) {
  const date = new Date(datestr);
  return new Intl.DateTimeFormat().format(date);
}

export function getDateSlug(dt=new Date()) {
  return dt
    .toISOString()
    .replace(/[-T:.Z]/g, '')
    .slice(0, 14);
}